import { HiOutlinePencil } from 'react-icons/hi'
import { Button } from '..'
import { color } from '../../../../../GlobalStyle'

const EditButton = ({ onClick }) => {
  return (
    <Button onClick={onClick} color={color.brand}>
      <HiOutlinePencil style={{ position: 'absolute' }} />
    </Button>
  )
}
export default EditButton
